/* CLD Home: slideshow, "Comprar por resultado" tabs, colour/version pickers and add to cart.
   Loaded by every cld-home-* section; runs once per page (guarded).
   Add to cart uses the theme's own cart (EOLUX.Cart) so the drawer refreshes and opens.
   Tools with a gift (product metafield cld.gift, 100 € or more) also add the Cepillo Anti-Frizz once
   per cart, with no tags: Shopify's automatic discount 'Regalo: Cepillo Anti-Frizz con tu herramienta'
   makes it free, exactly like the CLD buy box (cld-buybox.js). */
(function () {
  if (window.__cldHome) return;
  window.__cldHome = true;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Slideshow ---------- */
  function hero(root) {
    if (!root || root._cldh) return;
    var slides = root.querySelectorAll('[data-cldh-slide]');
    var dots = root.querySelectorAll('[data-cldh-dot]');
    var n = slides.length, i = 0, timer = 0;
    var secs = Math.max(3, +root.getAttribute('data-interval') || 6);
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce && n > 1;
    var paused = !auto;
    root._cldh = true;
    if (paused) root.classList.add('is-paused');

    function videos(slide, play) {
      each(slide.querySelectorAll('video'), function (v) {
        if (play && v.offsetParent !== null) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }
    function go(k) {
      if (!n) return;
      i = ((k % n) + n) % n;
      each(slides, function (s, j) {
        var on = j === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in s) s.inert = !on;
        videos(s, on);
      });
      each(dots, function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      restart();
    }
    function restart() {
      clearTimeout(timer);
      if (!paused && n > 1) timer = setTimeout(function () { go(i + 1); }, secs * 1000);
    }
    function setPaused(p) {
      paused = p;
      root.classList.toggle('is-paused', p);
      restart();
    }
    root._cldhGo = function (k) { setPaused(true); go(k); };

    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-cldh-dot]');
      if (d) { go(+d.getAttribute('data-cldh-dot')); return; }
      if (e.target.closest('[data-cldh-prev]')) { go(i - 1); return; }
      if (e.target.closest('[data-cldh-next]')) { go(i + 1); return; }
      if (e.target.closest('[data-cldh-pause]')) { setPaused(true); return; }
      if (e.target.closest('[data-cldh-play]')) { setPaused(false); }
    });
    /* Swipe on phones. */
    var x0 = null, y0 = 0;
    root.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; } }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    /* Stop when the tab is hidden; carry on when it comes back. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearTimeout(timer); else restart();
    });
    go(0);
  }

  /* ---------- Tabs: Comprar por resultado ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cldh-tab]');
    if (!t) return;
    var box = t.closest('[data-cldh-res]');
    if (!box) return;
    var k = t.getAttribute('data-cldh-tab');
    each(box.querySelectorAll('[data-cldh-tab]'), function (b) { b.setAttribute('aria-selected', b === t ? 'true' : 'false'); });
    each(box.querySelectorAll('[data-cldh-panel]'), function (p) { p.hidden = p.getAttribute('data-cldh-panel') !== k; });
    var rail = t.parentNode;
    if (rail && rail.scrollWidth > rail.clientWidth && rail.scrollTo) {
      rail.scrollTo({ left: t.offsetLeft - rail.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    }
  });

  /* ---------- Pickers (plancha colour + version, Jet Mini colour) ----------
     Buttons carry data-cldh-pick="<group>:<value>". The section holds the current choice in
     data-cldh-<group>; every element with data-cldh-key shows only when its key matches. */
  function applyKeys(box) {
    var c = box.getAttribute('data-cldh-c') || '0', o = box.getAttribute('data-cldh-o') || '';
    var key = o ? 'c' + c + '-' + o : 'c' + c;
    each(box.querySelectorAll('[data-cldh-key]'), function (el) {
      var ks = el.getAttribute('data-cldh-key').split(' ');
      el.hidden = ks.indexOf(key) < 0 && ks.indexOf('c' + c) < 0 && (o === '' || ks.indexOf(o) < 0);
    });
    each(box.querySelectorAll('[data-cldh-pick]'), function (b) {
      var p = b.getAttribute('data-cldh-pick').split(':');
      b.setAttribute('aria-pressed', (p[0] === 'c' ? p[1] === c : p[1] === o) ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cldh-pick]');
    if (!b) return;
    var box = b.closest('[data-cldh-picker]');
    if (!box) return;
    var p = b.getAttribute('data-cldh-pick').split(':');
    box.setAttribute('data-cldh-' + p[0], p[1]);
    applyKeys(box);
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cldh-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var E = window.EOLUX || {};
    var routes = E.routes || {};
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var addUrl = (routes.cart_add || rootUrl + 'cart/add') + '.js';
    var cartUrl = (routes.cart || rootUrl + 'cart') + '.js';
    var items = [{ id: +btn.getAttribute('data-variant'), quantity: 1 }];
    var giftId = +btn.getAttribute('data-gift') || 0;
    var giftProduct = +btn.getAttribute('data-gift-product') || 0;
    btn.setAttribute('aria-busy', 'true');

    var ready = !giftId ? Promise.resolve() : fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var has = (cart.items || []).some(function (it) {
          return it.variant_id === giftId || (giftProduct && it.product_id === giftProduct);
        });
        if (!has) items.push({ id: giftId, quantity: 1 });
      })
      .catch(function () {});

    ready.then(function () {
      var body = { items: items, sections: ['cart-drawer'] };
      if (E.Cart && E.Cart.request) return E.Cart.request(addUrl, body);
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }).then(function (data) {
      if (E.Cart && E.Cart.render) E.Cart.render(data && data.sections);
      var drawer = document.querySelector('[data-cart-drawer]');
      if (E.cartType === 'drawer' && drawer && E.Drawer) E.Drawer.open(drawer);
      else window.location.href = routes.cart || rootUrl + 'cart';
    }).catch(function (err) {
      var old = btn.innerHTML;
      btn.textContent = (err && err.message) || (E.strings && E.strings.cartError) || 'Error';
      setTimeout(function () { btn.innerHTML = old; }, 2600);
    }).then(function () {
      btn.removeAttribute('aria-busy');
    });
  });

  function init() {
    each(document.querySelectorAll('[data-cldh-hero]'), hero);
    each(document.querySelectorAll('[data-cldh-picker]'), applyKeys);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  /* Theme editor: selecting a slide in the left list shows it and pauses. */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target, root = el && el.closest && el.closest('[data-cldh-hero]');
    if (!root || !root._cldhGo) return;
    var all = root.querySelectorAll('[data-cldh-slide]');
    for (var k = 0; k < all.length; k++) if (all[k] === el) root._cldhGo(k);
  });
})();
